<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" v-if="!allListings || allListings.length === 0">
        <md-card>
          <md-card-content>
            <p class="text-center">No listings found. Create your first listing to get started.</p>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" v-if="allListings && allListings.length > 0">
        <stats-card data-background-color="green" class="listing_item" v-for="item in allListings" :key="item.id || Math.random()">
          <template slot="header">
            <md-icon>store</md-icon>
          </template>
          <template slot="content">
            <p class="category">{{getPropertyTypeName(item)}}</p>
            <h3 class="title">{{getPriceDisplay(item)}}</h3>
            <span v-if="item.draft == 1" class="not_published">Not Published</span>
            <span v-else class="published">Published</span>
          </template>
          <template slot="footer">
            <div class="stats">
              <div class="listing_item-details d-flex ">

                <div v-if="item.images && item.images.length > 0" class="listing_item-image">
                  <b-carousel
                      fade
                      indicators
                      img-width="300"
                      img-height="200"
                  >
                    <b-carousel-slide
                        v-for="(image, i) in item.images"
                        :key="i"
                        :img-src="getImageUrl(image)"
                    >
                    </b-carousel-slide>
                  </b-carousel>
                </div>
<!--                <img  :src="item.images[0].url" alt="">-->
                <img v-else src="@/assets/images/no_image.png" alt="">
                <div class="card_content">
                  <div>
                    <h4 class="listing_item-name">{{getListingName(item)}}</h4>
                    <p class="listing_item-text">{{getAddress(item)}}</p>
                    <p class="listing_item-text">
                      <b>Tags:</b> 
                      <span v-if="getTags(item).length > 0">
                        <span v-for="(tag, index) in getTags(item)" :key="tag.id || index">
                          {{tag.name || tag}}{{index < getTags(item).length - 1 ? ', ' : ''}}
                        </span>
                      </span>
                      <span v-else>No tags</span>
                    </p>
                  </div>
                  <div class="listing_item-btns">
                    <md-button class="md-success mr-2" @click="showDetails(item)" :disabled="!item || !item.id"><md-icon >menu</md-icon> Details</md-button>
                    <md-button class="md-primary mr-2" @click="editDetails(item.id)" :disabled="!item || !item.id"><md-icon >edit</md-icon> Edit</md-button>
                    <md-button class="md-danger mr-2" @click="delListing(item.id)" :disabled="!item || !item.id"><md-icon >delete_outline</md-icon> Delete</md-button>
                  </div>
                </div>
              </div>
<!--              <md-icon>date_range</md-icon>-->
<!--              Last 24 Hours-->
            </div>
          </template>
        </stats-card>
      </div>
    </div>

    <md-dialog-confirm
        :md-active.sync="active"
        md-title="Are you sure you want to proceed with this deletion?"
        md-content="Deleting this listing will result in the permanent removal of the following: <br/>
        All listing details, including reservations and payments <br/>
        All message templates and message template groups that are exclusively <br/>
        connected to this listing <br/>
        All message automations that are exclusively connected to this listing <br/>
        All financial and payment details associated with the listing <br/>
        Note that deleted listing information cannot be restored."
        md-confirm-text="Delete"
        md-cancel-text="Cancel"
        @md-cancel="onCancel"
        @md-confirm="onConfirm" />

  </div>

</template>

<script>
import {StatsCard,} from "@/components";
import carousel from 'vue-owl-carousel'
import {mapActions} from "vuex";
export default {
  name: "Listings",
  components: {
    StatsCard,
    carousel
  },
  data() {
    return {
      active: false,
      selectedId: null,
      allListings: []
    };
  },
  mounted() {
    this.getListings()
  },
  methods: {
    ...mapActions([
        'getAllListings',
        'deleteListing',
    ]),
    getListings() {
      this.getAllListings()
          .then(res => {
            if (res && res.data && res.data.data) {
              this.allListings = res.data.data;
            } else {
              this.allListings = [];
            }
          })
          .catch(err => {
            console.error('Error loading listings:', err);
            this.allListings = [];
          })
    },
    delListing(id) {
      this.selectedId = id
      this.active = true
    },
    onConfirm () {
      this.deleteListing(this.selectedId)
      .then(res => {
        if(res.status == 200 || res.status == 201) {
          this.selectedId = null
          this.active = false
          this.getListings()
        }
      })
    },
    onCancel () {
      this.active = false
    },
    showDetails(item) {
      if (!item || !item.id) {
        console.error('Cannot show details: item or item.id is missing');
        return;
      }
      // this.$store.commit('set_listing_details', item)

      // "{name: 'AdminDetails', params: {id: data.item.id, title: data.item.job_title}}"
      this.$router.push({name: 'ListingDetails', params: {id: item.id}})
    },
    editDetails(id) {
      if (!id) {
        console.error('Cannot edit: id is missing');
        return;
      }
      this.$router.push({name: 'EditListing', params: {id: id}})
    },
    getCurrencySymbol(currencyCode) {
      if (!currencyCode) return '';
      try {
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        // Extract symbol by formatting a value and removing the digits
        const parts = formatter.formatToParts(1);
        const symbolPart = parts.find(part => part.type === 'currency');
        return symbolPart ? symbolPart.value : currencyCode;
      } catch (e) {
        return currencyCode; // fallback if the currency code is invalid
      }
    },
    getPropertyTypeName(item) {
      return (item && item.property_type && item.property_type.name) ? item.property_type.name : 'N/A';
    },
    getPriceDisplay(item) {
      if (!item || !item.price_and_fee) {
        return 'N/A';
      }
      const currencyCode = item.price_and_fee.currency_code;
      const price = item.price_and_fee.price;
      if (!currencyCode && !price) {
        return 'N/A';
      }
      const symbol = currencyCode ? this.getCurrencySymbol(currencyCode) : '';
      return `${symbol} ${price || 'N/A'}`.trim();
    },
    getListingName(item) {
      return (item && item.external_listing_name) ? item.external_listing_name : 'Untitled Listing';
    },
    getAddress(item) {
      return (item && item.address && item.address.address) ? item.address.address : 'Address not specified';
    },
    getTags(item) {
      return (item && item.tags && Array.isArray(item.tags)) ? item.tags : [];
    },
    getImageUrl(image) {
      return (image && image.url) ? image.url : require('@/assets/images/no_image.png');
    },

  }

}
</script>

<style scoped lang="scss">
::v-deep .listing {
  &_item {
    &-details {
      margin: 0 16px;
      @media screen and (max-width: 1024px) {
        margin: 0;
      }
      & img {
        width: 300px;
        height: 200px;
      }
      & .card_content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 0 48px;
        @media screen and (max-width: 1024px) {
          margin: 0 16px;
        }
      }
    }
    &-image {
      width: 300px !important;
      height: 200px !important;
      @media screen and (max-width: 1024px) {
        width: 260px !important;
      }
      @media screen and (max-width: 450px) {
        width: 200px !important;
      }
      & img {
        width: 300px !important;
        height: 200px !important;
        @media screen and (max-width: 500px) {
          object-fit: cover !important;
        }
        @media screen and (max-width: 450px) {
          width: 200px !important;
        }
      }
    }
    &-name {
      color: green;
    }
    &-text {
      font-weight: 600;
      padding: 5px 0;
    }
    &-btns {
      padding: 10px 0;
      @media screen and (max-width: 1200px) {
        display: flex !important;
        flex-direction: column !important;
      }
      @media screen and (max-width: 450px) {
        display: flex !important;
        flex-direction: column !important;
      }
      & button {
        @media screen and (max-width: 1200px) {
          margin: 4px 0 !important;
        }
        @media screen and (max-width: 450px) {
          margin: 4px 0 !important;
        }
        & .md-ripple {
          @media screen and (max-width: 1024px) {
            padding: 8px 16px !important;
          }
          @media screen and (max-width: 450px) {
            width: 100px !important;
            padding: 6px 10px;
          }
        }
      }

    }

  }
}
.published {
  background: rgba(0, 210, 104, 0.15);
  color: #007A3D;
  padding: 3px 6px;
  border-radius: 4px;
}
.not_published {
  background: rgba(255, 153, 0, 0.15);
  color: #C47B00;
  padding: 3px 6px;
  border-radius: 4px;
}
</style>
